import { useEffect, useState } from 'react';
import { dollarTemplate } from '../../../lib/utils';
import { ReactComponent as EditIcon } from '../../../images/icons/edit-alternative.svg';
import EditModal from '../../common/Modals/EditModal';
import { useLabOrderDetailsStore } from '../../../stores';

const BillDetails = () => {
  const {
    order,
    isAdmin,
    refundOrder,
    refund,
    setRefund,
    isRefundModalOpen,
    setIsRefundModalOpen,
    resetRefundFromOrder,
  } = useLabOrderDetailsStore();
  
  const attributes = order?.data?.attributes;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (attributes) {
      setRefund({
        amount: attributes?.refundAmount ?? '',
        reason: attributes?.refundNote ?? '',
      });
    }
  }, [attributes, setRefund]);

  const saveRefund = async () => {
    setLoading(true);
    const parsedAmount = parseFloat(refund.amount);
    if (isNaN(parsedAmount)) {
      alert("Refund amount must be a valid number");
      setLoading(false);
      return;
    }
    const finalAmount = Number(parsedAmount.toFixed(2));
    try {
      await refundOrder(attributes?.guid, finalAmount, refund.reason);
      setIsRefundModalOpen(false);
    } catch (error) {
      console.error("Failed to save refund:", error);
      alert("Something went wrong while saving the refund.");
    } finally {
      setLoading(false);
    }
  };

  // Reset fields on cancel
  const handleRefundModalClose = () => {
    resetRefundFromOrder();
    setIsRefundModalOpen(false);
  };

  return (
    <div data-w-id="88c8398a-15de-8814-f63f-d95b5bbbc025" className="order-2nd-div">
      <div className="w-layout-grid grid-bottom-details">
        <div>
          {isAdmin && (
            <div
              id="w-node-aeb2fb91-2b12-b2d2-b3f8-4129190addde-6be80a0f"
              className="div-block-details"
            >
              <h2 className="heading-title">Refund Details</h2>
              <div className="grid-details right-copy">
                <div className="container-details full">
                  <div className="text-details-container">
                    <div>Refund Total:</div>
                  </div>
                  <div>{dollarTemplate(attributes.refundAmount)}</div>
                </div>
                <div className="horizontal-line"></div>
                <div className="container-details full">
                  <div className="text-details-container">
                    <div>Reason:</div>
                  </div>
                </div>
                <p className="paragraph-3">{attributes?.refundNote}</p>
              </div>

              {/* Trigger Button */}
              <div className="w-layout-grid grid-button-notes">
                <a
                  href="#"
                  className="_2nd-button main smaller transparent w-inline-block"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsRefundModalOpen(true);
                  }}
                >
                  <div className="icon smaller right-margin w-embed">
                    <EditIcon />
                  </div>
                  <div>Add / Edit Refund</div>
                </a>
              </div>
            </div>
          )}
        </div>

        {/* Bill Details */}
        <div
          id="w-node-_652204d4-e5ff-36d4-25fb-e3b74f1e5df7-fde80a15"
          className="div-block-details"
        >
          <h2 className="heading-title">Bill Details</h2>
          <div className="grid-details right-copy">
            <div className="container-details full">
              <div className="text-details-container">
                <div>Subtotal:</div>
              </div>
              <div>{dollarTemplate(attributes.subtotal)}</div>
            </div>

            <div className="container-details full">
              <div className="text-details-container">
                <div>Shipping:</div>
              </div>
              <div>{dollarTemplate(attributes.shippingTotal)}</div>
            </div>

            <div className="container-details full">
              <div className="text-details-container">
                <div>Credit Used:</div>
              </div>
              <div>{dollarTemplate(attributes.creditApplied)}</div>
            </div>

            <div className="container-details full">
              <div className="text-details-container">
                <div>Discount:</div>
              </div>
              <div>{dollarTemplate(attributes.discount)}</div>
            </div>

            <div className="horizontal-line" />

            <div className="container-details _2">
              <div
                id="w-node-_652204d4-e5ff-36d4-25fb-e3b74f1e5e13-fde80a15"
                className="text-details-container"
              >
                <div>Total:</div>
              </div>
              <h2 className="heading-title">{dollarTemplate(attributes.total)}</h2>
            </div>

            <div className="container-details full red">
              <div className="text-details-container">
                <div>Refund Total:</div>
              </div>
              <div>{dollarTemplate(attributes.refundAmount)}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Refund Modal */}
      <EditModal
        loading={loading}
        isOpen={isRefundModalOpen}
        onClose={handleRefundModalClose}
        title="Add / Edit Refund"
        icon={EditIcon}
        fields={[
          {
            placeholder: "Enter Refund Amount",
            value: refund.amount,
            onChange: (val) => setRefund({ ...refund, amount: val }),
            required: true,
          },
          {
            placeholder: "Refund Reason",
            value: refund.reason,
            onChange: (val) => setRefund({ ...refund, reason: val }),
            required: true,
          },
        ]}
        onSave={saveRefund}
      />
    </div>
  );
};

export default BillDetails;
